import Link from "next/link";
import React, { FC } from "react";

import { MainTitle } from "@/components/atoms/typograhies/MainTitle";
import ChevronIcon from "public/icon/chevron-right.svg";

interface Props {
  title: string;
  className?: string;
  backLink?: string;
  backLinkText?: string;
}

export const PageHeader: FC<Props> = ({
  title,
  className,
  backLink,
  backLinkText,
}) => {
  return (
    <div className="space-y-4 md:space-y-0 md:h-auto">
      <div className="h-6 md:hidden">
        {backLinkText && backLink && (
          <Link
            href={backLink}
            className="inline-flex items-center font-bold text-primary-dark">

            <div>
              <ChevronIcon className="mr-1 w-4 h-4 -scale-x-90 fill-primary-dark" />
            </div>
            {backLinkText}

          </Link>
        )}
      </div>
      <MainTitle className={className} title={title} />
    </div>
  );
};
